import Dropzone from '../../../node_modules/dropzone/index';


/**
 * Created by PhpStorm
 * Author: Mikhail Zheludkov <mzheludkov@clubautomation.com>
 * Date: 02/16/2016
 * Time: 2:24 PM
 *
 * The widget for a File Upload control
 */
(function($) {
    $.widget('ca.caFileUploadSimple', {
        options: {
            url: '/mail/upload-with-ext',
            acceptedFiles: null,
            showErrorForAcceptedFiles: null,
            maxFileSize: null,
            maxFiles: null,
            messageReplaceKeyword: 'MAXSIZE',
            fileSizeMessageTemplate: 'File is too big. Max filesize: MAXSIZE MiB',
            hideControl: false,
            existingFiles: null,
            minImageWidth: null,
            minImageHeight: null,
            aspectRatio: null
        },

        _create: function () {
            try{
                var controlId = '#' + this.element.prop('id');
                var previewNode = document.querySelector(controlId + "template");
                previewNode.id = "";
                var previewTemplate = previewNode.parentNode.innerHTML;
                previewNode.parentNode.removeChild(previewNode);
                var lastFile;

                var self = this;

                Dropzone.autoDiscover = false;

                var myDropzone = new Dropzone(controlId, {
                    url: this.options.url,
                    createImageThumbnails: true,
                    previewTemplate: previewTemplate,
                    autoQueue: false,
                    previewsContainer: controlId + 'Container',
                    clickable: controlId + ' .fileinput-button',
                    paramName: "attachment",
                    acceptedFiles: this.options.acceptedFiles
                });

                myDropzone.on("addedfile", function(file) {
                    setTimeout(function() {
                        lastFile = file;
                        myDropzone.enqueueFile(file);
                    }, 100);
                });
                myDropzone.on("removedfile", function (file) {
                    if (self.options.hideControl) {
                        $('#actions').toggle();
                    }
                });
                myDropzone.on("success", function(event, response) {
                    var emptyRow = $($(controlId + ' .file-row-empty').get(0));
                    emptyRow.removeClass('file-row-empty').addClass('file-row-filled');
                    emptyRow.find('.attachment_json').val(response);

                    var fileTypeSelect = emptyRow.find(".dz-success .file-type-select");
                    if (fileTypeSelect.length > 0) {
                        fileTypeSelect.attr('name', 'doc_type[]')
                            .caSelect({"width": 100, "selectType": "select"});
                    }

                    if (self.options.hideControl) {
                        $('#actions').toggle();
                    }
                });
                myDropzone.on('error', function(event){
                    var emptyRow = $($(controlId + ' .file-row-empty').get(0));
                    emptyRow.detach();
                    $.caAlert('Could not upload file ' + lastFile.name + '.');
                });

                myDropzone.on('complete', function (file) {
                    var message = '';
                    if (self.options.maxFileSize && file.size > self.options.maxFileSize * 1024 * 1024) {
                        this.removeFile(file);
                        message = self.options.fileSizeMessageTemplate.replace(
                            self.options.messageReplaceKeyword,
                            self.options.maxFileSize
                        );
                        $.caAlert(message,'' ,{fade:true});
                        return false;
                    }
                    if (self.options.minImageWidth && file.width < self.options.minImageWidth) {
                        this.removeFile(file);
                        message = 'Minimum allowed image width is ' + self.options.minImageWidth;
                        $.caAlert(message, '', {fade: true});
                        return false;
                    }
                    if (self.options.minImageHeight && file.height < self.options.minImageHeight) {
                        this.removeFile(file);
                        message = 'Minimum allowed image height is ' + self.options.minImageHeight;
                        $.caAlert(message, '', {fade: true});
                        return false;
                    }

                    if (self.options.aspectRatio) {
                        var $width = file.width;
                        var $height = file.height;
                        var $numerator = 1;
                        var $denominator = 1;
                        [$numerator, $denominator] = self.options.aspectRatio.split(':');
                        var $precision = 1 / Math.max($width, $height);
                        if (Math.abs($numerator / $denominator - $width / $height) > $precision) {
                            this.removeFile(file);
                            message = 'The aspect ratio of the image should be ' + self.options.aspectRatio;
                            $.caAlert(message, '', {fade: true});
                            return false;
                        }
                    }
                    if (self.options.acceptedFiles && self.options.showErrorForAcceptedFiles && !file.type.match(self.options.acceptedFiles)) {
                        this.removeFile(file);
                        $.caAlert('You can\'t upload files of this type');

                        return false;
                    }

                    if (self.options.maxFiles && this.files[self.options.maxFiles] != null) {
                        this.removeFile(file);
                        $.caAlert('You can not upload any more files');

                        return false;
                    }
                });
                if (self.options.existingFiles) {
                    $.each(self.options.existingFiles, function (key, value) {
                        var mockFile = {
                            name: value.name,
                            size: typeof value.size != 'undefined' ? value.size : 0,
                            type: value.type
                        };

                        mockFile.status = Dropzone.ADDED;
                        mockFile.accepted = true;

                        myDropzone.emit("addedfile", mockFile);
                        myDropzone.emit("success", mockFile, JSON.stringify(value));
                        myDropzone.emit("complete", mockFile);
                    });
                }
            } catch (error) {
                alert("Catching " + error);
            }
        }
    });
})(jQuery);
